import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal
} from '@angular/core';
import {IAuthInfo} from '@service-and-repairs/awpintegrationlib';
import {CustomerDataFrontendService} from './customer-data-frontend.service';

/**
 * Embeds the Customer Data Frontend's search web component, which allows searching for customers and license plates.
 */
@Component({
  selector: 'app-customer-data-search',
  templateUrl: './customer-data-search.component.html',
  styleUrls: ['./customer-data-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CustomerDataSearchComponent {
  // The user's locale and business partner are passed as plain values, because the user object is modified in place
  // when the outlet is switched, which would not be recognized as a change of an input.
  readonly locale: InputSignal<string> = input<string>();
  readonly businessPartnerId: InputSignal<string> = input<string>();
  readonly authInfo: InputSignal<IAuthInfo> = input<IAuthInfo>();

  /**
   * Emits the VIN of the vehicle the user selected in the Customer Data Frontend.
   */
  readonly vinSelected: OutputEmitterRef<string> = output<string>();

  /**
   * Emits the account number of the customer whose profile the user wants to open.
   */
  readonly customerProfileSelected: OutputEmitterRef<string> = output<string>();

  protected readonly baseUrl: string = inject(CustomerDataFrontendService).getBaseUrl();

  // The web component expects the authentication information as a JSON string.
  protected readonly authInfoJson: Signal<string>
    = computed((): string => this.authInfo() ? JSON.stringify(this.authInfo()) : undefined);

  protected handleSelectVehicle(event: Event): void {
    const vin: string = (event as CustomEvent)?.detail?.vin;
    if (vin) {
      this.vinSelected.emit(vin);
    }
  }

  protected handleOpenCustomerProfile(event: Event): void {
    const accountNumber: string = (event as CustomEvent)?.detail?.accountNumber;
    if (accountNumber) {
      this.customerProfileSelected.emit(accountNumber);
    }
  }
}
